(function(){
    if (window.__brfPerf || !('IntersectionObserver' in window)) return; window.__brfPerf = true;
    var SKIP = '[role="dialog"],.modal,.drawer,[class*="drawer"],[class*="modal"],[class*="popup"]';
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ e.target.classList.toggle('brf-off', !e.isIntersecting); });
    }, {rootMargin: '200px 0px'});
    function obs(el){ if (el.__brfIo) return; el.__brfIo = 1; io.observe(el); }
    /* a tall section (like the whole home page) is watched in parts, so its lower blocks pause while you're at the top */
    function kids(n){ return [].filter.call(n.children, function(c){ return !/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(c.tagName); }); }
    function parts(s){
      var n = s, k = kids(n);
      for (var d = 0; d < 4 && k.length === 1; d++) { n = k[0]; k = kids(n); }
      return k.length >= 3 ? k : null;
    }
    function watch(){
      [].forEach.call(document.querySelectorAll('#main > .shopify-section, #main > section, .shopify-section-group-footer-group'), function(s){
        if (s.__brfSeen || s.querySelector(SKIP)) return; s.__brfSeen = 1;
        var p = s.offsetHeight > innerHeight * 1.5 && parts(s);
        if (p) p.forEach(obs); else obs(s);
      });
    }
    /* product cards are watched one by one (a collection page can hold 50+ "only a few left" pulses) */
    function cards(){ [].forEach.call(document.querySelectorAll('.product-item'), obs); }
    function all(){ watch(); cards(); }
    all(); window.addEventListener('load', all);
    ['brf:filtered', 'theme:loading:end', 'cart:rerendered'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(all, 120); }); });
  })();
